exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SF36YAW0c4jd_SN2CiDjZ{display:flex;flex-direction:column;justify-content:flex-start}._3OSGULVVDS7h-kaQtDZMVE>a{font-weight:500}._1_IuAAfd_JHAbYhSmMDZt5{display:flex;margin-bottom:20px}\n", ""]);

// Exports
exports.locals = {
	"emptyCard": "SF36YAW0c4jd_SN2CiDjZ",
	"secondaryColCard": "_3OSGULVVDS7h-kaQtDZMVE",
	"emptyTop": "_1_IuAAfd_JHAbYhSmMDZt5"
};